import { render, staticRenderFns } from "./delivery-pick.vue?vue&type=template&id=27a4f404&scoped=true"
import script from "./delivery-pick.vue?vue&type=script&lang=js"
export * from "./delivery-pick.vue?vue&type=script&lang=js"
import style0 from "./delivery-pick.vue?vue&type=style&index=0&id=27a4f404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4f404",
  null
  
)

export default component.exports